import { supabase } from 'src/services/supabase-client';
import { WeightEntity } from '../types/weight';

export const removeWeight = async (id: string): Promise<void> => {
  await supabase
    .from<WeightEntity>('weights')
    .update({ deleted: true })
    .eq('id', id);
};
